import React from 'react'
import Param from '../store/param';

import FormSetup from './formSetup';
import FormAlign from './formAlign';
import FormBaseShape from './formBaseShape';
import FormCompress from './formCompress';
import FormCompressScan from './formCompressScan';
import FormTrim1 from './formTrim1';
import FormTrim2 from './formTrim2';
import FormAssemble from './formAssemble';
import FormOutput from './formOutput';

/*
import FormMarking from './formMarking';
import FormModify from './formModify';
import FormTrim from './formTrim';
import FormThick from './formThick';
import FormJoint from './formJoint';
*/

const FormTest = () => {
  const activeStep = Param.Get('activeStep');
  const akModeling = Param.Get('setup')['akModeling'];
  
  switch (activeStep) {
    case 0:
      return <FormSetup/>;
    case 1:
      return <FormAlign/>;
    case 2:
      return <FormBaseShape/>;
    case 3:
      if (akModeling == 0) {
        return <FormCompress/>;
      } else if (akModeling == 1) {
        return <FormCompressScan/>;
      }
    case 4:
      return <FormTrim1/>;
    case 5:
      return <FormTrim2/>;
      case 6:
      return <FormAssemble/>;
    case 7:
      return <FormOutput/>;
    default:
      return 'Unknown step';
  }
  
}

export default FormTest
